import "./style.less";

export default function PrioLane() {
    return {
        restrict: "E",
        scope: {
            prioLane: "=",
        },
        template: require("./template.html"),

        controller: function (
            $scope,
            $rootScope,
            siteService,
            $q,
            $timeout,
            Basket,
            Log
        ) {
            $scope.siteService = siteService;
            $scope.activityItemName = $scope.prioLane.details.activityItemName;

            const log = {
                string: (string, theme = "info") => {
                    Log.string("prio Lane", string, theme);
                },
                obj: (title, obj, theme = "info") => {
                    Log.obj("prio Lane : " + title, obj, theme);
                },
            };

            var removedBookingEventListener = $rootScope.$on(
                "booking-removed-basket",
                function () {
                    log.string(
                        " PRIO $on - booking-removed-basket",
                        "booking-removed-basket",
                        "highlight"
                    );

                    updatePrioLane();
                }
            );

            $scope.$on("$destroy", removedBookingEventListener);

            const updatePrioLane = () => {
                $scope.prioLane.timeSlots.map((timeslotGroup) => {
                    return updateTimeslotGroup(timeslotGroup);
                });
            };

            /***
             * VOID
             * Will update timeslotGroup in $scope
             */
            const updateTimeslotGroup = (timeslotGroup) => {
                $timeout(() => {
                    timeslotGroup = syncWihBasket(timeslotGroup).then(
                        (timeslotGroup) => {
                            // Find the count
                            timeslotGroup.available =
                                timeslotGroup.periods.filter((period) => {
                                    if (!period.selected) {
                                        return period;
                                    }
                                }).length;

                            return timeslotGroup;
                        }
                    );
                });
            };

            const syncWihBasket = (timeslotGroup) => {
                const basketBookings = Basket.getBookings();

                timeslotGroup.hasPeriodInBasket = false;

                timeslotGroup.periods.map((period) => {
                    let match = false;
                    basketBookings.map((booking) => {
                        // Assumption (always one period)
                        if (period.UniqueKey == booking.Periods[0].UniqueKey) {
                            match = true;
                            period.selected = true;
                            timeslotGroup.hasPeriodInBasket = true;
                        }
                    });

                    if (!match) {
                        period.selected = false; // ensure its set (issue on reload remove from basket)
                    }
                });

                return $q.resolve(timeslotGroup);
            };

            $scope.addPrioToBasket = (timeslotGroup) => {
                if (timeslotGroup.available == 0) {
                    return false;
                }

                const foundPeriod = timeslotGroup.periods.find((period) => {
                    /**
                     * Since the array is allready sorted by hightest priority (index 0),
                     * we just need to check find the first available period.
                     */
                    // ONLY ADD IF AVAILABLE
                    if (period.Available && period.selected == false) {
                        period.selected = true;
                        return period;
                    }
                });

                if (!foundPeriod) {
                    return false;
                }

                /**
                 * legacy basket wants this
                 */
                const neededLaneProps = {
                    LaneID: foundPeriod.LaneID,
                    LaneName: foundPeriod._laneName,
                    Priority: foundPeriod._lanePriority,
                };

                Basket.addPeriod(neededLaneProps, foundPeriod).then(
                    () => {
                        timeslotGroup = updateTimeslotGroup(timeslotGroup);
                        $scope.message = null;
                    },
                    (err) => {
                        $scope.message = err;
                    }
                );
            };

            // INIT
            updatePrioLane();

            // Create label for WCAG compliance
            $scope.getLabel = (slot) => {
                const startHour = parseInt(slot.start.substring(0, 2));
                const startMinutes = parseInt(slot.start.substring(3, 5));

                const endHour = parseInt(slot.end.substring(0, 2));
                const endMinutes = parseInt(slot.end.substring(3, 5));

                return `klokken ${startHour} ${
                    startMinutes > 0 ? startMinutes : ""
                } til ${endHour} ${endMinutes > 0 ? endMinutes : ""}`;
            };
        },
    };
}
